module.exports = __webpack_public_path__ + "img/sal-17.17081a27.jpg";